import Show from '../../Download/Show';
import React, { useState, useEffect } from 'react';
// import '../../../Style/Form.css'
import PercentageAdd from '../../Award/PercentageAdd'
import Bladge from '../../Award/Bladge'
import Userans_check from '../../Download/User_check'
const FlashAddFun = ({ mat, ques, row, file, dicrange }) => {
  const twoDArray = mat;

  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [currentColIndex, setCurrentColIndex] = useState(null);
  const [isRunning, setIsRunning] = useState(false);
  const [getans, getansinp] = useState()
  const [start, setStart] = useState(0)
  const [ans, setans] = useState([])
  const [hidenext, sethidenext] = useState(false)
  const [last, islast] = useState(0)
  const [Shows, setShows] = useState(0);
  const [hidestart, sethidestart] = useState(0)
  const [isans, setisans] = useState(1)
  let totalcolum ;
  const handleStart = () => {
    sethidestart(true)
    setCurrentRowIndex(0); // Start from the first row
    setCurrentColIndex(0); // Start from the first column
    setIsRunning(true);
  };

  const handleNext = (event) => {
    event.preventDefault();
    ans.push(getans)
    getansinp('')
    setTimeout(() => {
      if (currentColIndex === twoDArray[currentRowIndex].length - 1) {
        if (currentRowIndex < twoDArray.length - 1) {
          setCurrentRowIndex(prevIndex => prevIndex + 1); // Move to the next row
          setCurrentColIndex(0); // Reset column index
        } else {
          setIsRunning(false); // Stop when all rows are displayed
          islast(true)
        }
      }
    },1500);


  };

  useEffect(() => {
    let interval;
    if (isRunning) {
      sethidenext(true)
      interval = setInterval(() => {
        if (currentColIndex !== twoDArray[currentRowIndex].length - 1) {
          setCurrentColIndex(prevIndex => prevIndex + 1); // Move to the next column
          console.log(dicrange)
        } else {
          sethidenext(false)
          clearInterval(interval);
        }
      }, dicrange);
    }
    return () => clearInterval(interval);
  }, [isRunning, currentRowIndex, currentColIndex]);




  return (
    <div className='card-show-download'>
      <div className={start ? 'dic-input' : "dic-hide-input"}>
        <form onSubmit={handleNext} className='input-form'>
          <div className={last ? "hide-btn-download" : ' iner-main-card flash-card'}>{isRunning &&  (
            <div className={currentColIndex==row-1?"endrow":"row"}>
            <h1 >{twoDArray[currentRowIndex][currentColIndex]}</h1>
            </div>
          )}</div>
          <div className='input'>
            <input type={"number"} className={last ? "hide-btn" : 'box'} value={getans} required onChange={(e) => { getansinp(e.target.value) }} id='input' />
          </div>
          <div className='in'>
            <input type='submit' className={last ? "hide-final" : "bt-purple"} value="Next" />
          </div>
        </form>
        <div className={last ? "mark-card" : "hide-final"}>
          <div className='mark-card-1'>
            <button className={Shows ? "" : "bt-purple"} onClick={() => { Shows ? setShows(0) : setShows(1) }}>{Shows ? '' : "Show"}</button>
            <div className={Shows ? "display-ans" : "hide-btn"}>
              {/* <button className='X-btn-show' onClick={() => { setShows(0) }}>X</button> */}
              <Show {...{ row, mat, ques ,ans}} />
            </div>
          </div>
          <div className='mark-card-2'>
            <Userans_check {...{ mat, ques, row, ans,ch:"a", last, file ,isans}} />
          </div>
          <PercentageAdd {...{ mat, ques, row, ans ,ch:"a",last }} />
        </div>
      </div>
      <div className={last ? "show-bladge" : "hide-bladge"}>
        <Bladge {...{ mat, ques, row, ans , ch:"a",last }} />
      </div>
      <button className={hidestart ? "hide-btn" : "bt-purple"} onClick={() => { setStart(true); handleStart() }}>Start</button>
    </div>
  );
};

export default FlashAddFun;
